<script>
import Loading from '@/components/general/Loading.vue'
import EmptyList from '@/components/general/EmptyList'
import InputField from '@/components/general/InputField'
import Breadcrumbs from '@/components/general/Breadcrumbs'
import UserListItem from '@/components/general/UserListItem'
export default {
  name: 'Auditors',
  components: {
    UserListItem,
    Breadcrumbs,
    InputField,
    EmptyList,
    Loading
  },
  data () {
    return {
      data: [],
      users: [],
      search: '',
      isReady: false,
      itemsLength: 0
    }
  },
  created () {
    this.getAuditors()
  },
  methods: {
    refreshData (data) {
      this.users = data.users.map(user => ({
        id: user.id,
        role: user.role,
        email: user.email,
        name: user.fullName,
        auditor: user.auditor,
        fullName: user.fullName,
        lastName: user.fullName.split(' ').slice(1).join(' '),
        avatarImage: user.avatar.indexOf('/empty') === -1 ? user.avatar : '/assets/images/profile-avatar.jpg'
      }))
      this.data = this.users
      this.itemsLength = data.users.length
    },
    getAuditors () {
      this.$store.dispatch('attemptGetAuditors').then(({ data }) => {
        this.isReady = true
        this.refreshData(data)
      })
    },
    updateAuditor (value) {
      this.$store.dispatch('attemptUpdateAuditor', value).then((data) => {
        this.refreshData(data)
      }).catch(err => {
        if (err) {
          console.log(err)
        }
      })
    }
  },
  watch: {
    search: function (value) {
      const filter = this.users = this.data.filter(item => {
        return item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
      })
      this.itemsLength = filter.length
    }
  },
  computed: {
    breadcrumbsPaths () {
      const path = [{ text: 'admin.center:menu.8:title', href: this.$route.path }]
      return path
    }
  }
}
</script>
<template>
  <section class="auditors--container center-small">
    <div class="default-header">
      <breadcrumbs :items="breadcrumbsPaths"/>
      <h2>{{ $t('admin.center:auditors.title') }}</h2>
    </div>
    <Loading v-if="!isReady"/>
    <div v-else>
      <div class="auditors--filter-actions">
        <input-field class="mr-2" outlined dense :label="$t('global:search.alt')" v-model="search" append-icon="mdi-magnify"></input-field>
      </div>
      <div class="active-users--list">
        <empty-list v-if="users.length === 0" :title="$t('empty.state.title:active.user.active.title')" :textOne="$t('empty.state.text:active.user.active.text')" :image="'/assets/images/empty-bush.png'"></empty-list>
        <user-list-item v-for="user in users" :key="user.id" :user="user" @userDeleted="getAuditors()" @change="val => updateAuditor({ id: user.id,  auditor: val })"></user-list-item>
      </div>
    </div>
  </section>
</template>
<style lang="scss">
.auditors--container {
  padding-bottom: 60px;
  .auditors--filter-actions {
    display: flex;
    justify-content: flex-end;
    text-align: right;
  }
}
</style>
